export const INTRO_HOME = `
<div class="reward-content">
  <div class="reward-part">
    <p style="text-align:left">
    Chương trình giao lưu văn hóa Việt Nam – Nhật Bản Heiwa Peace Tây Hồ kỷ niệm 50 năm thiết lập quan hệ ngoại giao Việt Nam – Nhật Bản với chủ đề “NHỮNG NHỊP CẦU HỮU NGHỊ” do UBND QUẬN T Y HỒ và CÔNG TY CỔ PHẦN SR PLANNING tổ chức, với mong muốn tạo ra cơ hội giao lưu văn hóa, quảng bá văn hóa Việt Nam ra quốc tế, mang văn hóa Nhật Bản tới gần hơn với người dân Việt Nam và thúc đẩy quan hệ ngoại giao chặt chẽ ở nhiều lĩnh vực giữa Việt Nam và Nhật Bản. Chương trình hứa hẹn sẽ là một sẽ là dịp hấp dẫn để các bạn trẻ trên cả nước tham gia trải nghiệm và khám phá các nét văn hoá đặc sắc của Nhật Bản. Và để góp phần sôi động cho chương trình, BTC phát động cuộc thi “Miss Heiwa Peace Tây Hồ 2023” nhằm mang đến cơ hội để các thí sinh thể hiện vẻ đẹp và tài năng của người phụ nữ Việt Nam, hơn nữa cuộc thi còn là dịp giao lưu văn hóa, tăng cường hiểu biết và đoàn kết giữa hai quốc gia
    </p>
    </div>
  </div>
</div>
`;

export const INTRO_TITLE = `Là cổng bình chọn chính thức của cuộc thi Miss Heiwa Peace Tây Hồ 2023, Bvote tự hào mang đến giải pháp bình chọn trực tuyến công bằng, minh bạch cho các thí sinh.`;

export const INTRO = `
  <div class="reward-content">
  <div class="reward-part">
<div class="item">
<p>
<span style="font-size:16px; font-family: roboto; ">
<span style="color:#000000">
<span style="font-family:roboto">
Cổng bình chọn Bvote sẽ đồng hành cùng cuộc thi để tìm kiếm ra những thí sinh được yêu thích nhất qua sự bình chọn của khán giả. 
  </span>
  </span>
  </span>
  </p>
   <p>
  <span style="font-size:16px"><span style="color:#000000">
  <span style="font-family:roboto">
  Việc hoạt động dựa trên công nghệ chuỗi khối của Blockchain giúp giải pháp bình chọn của Bvote sở hữu những ưu điểm vượt trội về tính an toàn, bảo mật, đem lại kết quả công khai và minh bạch nhất. Thay vì sử dụng phương thức truyền thống bằng tin nhắn, khán giả sẽ ủng hộ cho thí sinh mình yêu thích nhất thông qua hệ thống bình chọn trên Website. Giải pháp này cho phép mọi người theo dõi kết quả liên tục, trực tiếp trên hệ thống, một điều mà các hình thức cũ không làm được. Không chỉ loại bỏ nguy cơ gian lận, Bvote còn mang đến trải nghiệm bình chọn mới lạ, tiện lợi và dễ sử dụng. Nhất là khi giải pháp bình chọn của Bvote còn kết hợp cùng các ví điện tử uy tín để đảm bảo mức độ bảo mật cao và giảm thiểu tối đa tình trạng hack vote.
  <br/>
  <br/>
  </span>
    </span>
      </p> 
      <p>
      &nbsp;
      </p> 
      <p>
      <span style="font-size:16px">
      <span style="color:#000000">
      <span style="font-family:roboto">
      <strong>
      Cách thức bình chọn:
      </strong>
      <br/>
      <br/>
      <strong>
      Ban tổ chức đưa lên thông tin thí sinh để khán giả bình chọn
      </strong>
      </span>
      </span>
      <span style="color:#000000">
      <span style="font-family:roboto"> 
      </span>
      </span>
      </span>
      </p>
       <p>
       <span style="font-size:16px">
       <span style="color:#000000">
       <span style="font-family:roboto">
       - <i>Bước 1: &nbsp;</i> Truy cập website: https://missheiwapeacetayho.bvote.vn/. Tại phần Danh sách thí sinh, click chi tiết vào thí sinh muốn bình chọn
       </span>
       </span>
       </span>
       </p> 
       <p>
       <span style="font-size:16px">
       <span style="color:#000000">
       <span style="font-family:roboto">
       - <i>Bước 2: &nbsp;</i> Click Bình chọn VNPAY hoặc Bình chọn qua Ngân hàng, thẻ. Hệ thống sẽ trả về 1 link thanh toán để bình chọn thí sinh.
       </span>
       </span>
       </span>
       </p>
        <p><span style="font-size:16px">
        <span style="color:#000000">
        <span style="font-family:roboto">
        - <i>Bước 3: &nbsp;</i> Truy cập link thanh toán, tiến hành thanh toán (tương đương bình chọn). 

        </span>
        </span>
        </span>
        </p>
         <p>
         <span style="font-size:16px">
         <span style="color:#000000">
         <span style="font-family:roboto">
         - <i>Bước 4: &nbsp;</i> Hệ thống check thanh toán thành công, hệ thống Bvote sẽ tiến hành lưu trữ kết quả bình chọn. Phí bình chọn theo gói lựa chọn và 1 lượt bình chọn tương đương với số điểm theo gói bình chọn mà khán giả đã chọn. Lưu ý sẽ không giới hạn số lượt bình chọn và số thí sinh bình chọn.
 
         </span>
         </span>
         </span>
         </p> 
   
         <br/>
          <p>
          &nbsp;
          </p> 
          <p>
          <span style="font-size:16px">
          <strong>
          <span style="color:#000000">
          <span style="font-family:roboto">
          Cơ cấu giải thưởng: 
          </span>
          </span>
          </strong>
          </span>
          </p> 
          <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
         Cổng bình chọn của Bvote sẽ chính thức được mở vào 20h00  ngày 08/12 và sẽ kết thúc vào 08h00 ngày 24/12.
          </p> 
          
               <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
+ Miss Heiwa Peace Tây Hồ: 10.000.000 vnđ tiền mặt, quà của nhà tài trợ và giấy chứng nhận 
          </p> 
          
          
               <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
+ Á khôi 1: 6.000.000 vnđ tiền mặt, quà của nhà tài trợ và giấy chứng nhận 
          </p> 
          
               <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
+ Á khôi 2: 4.000.000vnd tiền mặt, quà của nhà tài trợ và giấy chứng nhận 
          </p> 
          
               <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
+ Thí sinh được yêu thích nhất : 2.000.000 vnđ tiền mặt, quà của nhà tài trợ và giấy chứng nhận
          </p> 
          
</div>
</div>
</div>
  `;
